import React from 'react';
import styled from 'styled-components';
import CoreButton from 'gatsby-theme-core/src/components/button/index';
import Socialmedia from 'gatsby-theme-core/src/components/socialmedia';
import useSocialmedia from 'gatsby-theme-core/src/hooks/use-socialmedia';
import PagebuilderButton from 'gatsby-theme-pagebuilder/src/components/button/index';
import PagebuilderProviders from 'gatsby-theme-pagebuilder/src/components/providers';
import Image from 'gatsby-theme-core/src/components/image';
import useCompanies from 'gatsby-theme-core/src/hooks/use-companies';
import useCompany from 'gatsby-theme-core/src/hooks/use-company';
import Wrapper from 'gatsby-theme-menus/src/components/nav/cover-nav/wrapper';
import Rating from '../../../../components/cover-nav/addon-rating';
import useHeader from '../../../../hooks/use-header';

const Addons = ({ className }) => {
  const {
    facebook,
    youtube,
    linkedin,
    instagram,
    twitter,
    tiktok,
  } = useSocialmedia();
  const companies = useCompanies();
  const noOfCompanies = companies.length;
  const {
    name,
    email,
    tel,
    telWithCountryCode,
    tel2,
    tel2WithCountryCode,
    street,
    houseNumber,
    postcode,
    city,
  } = useCompany();
  const { items } = useHeader();
  return (
    <article className={className}>
      {(street || tel || email) && (
        <Wrapper>
          {noOfCompanies === 1 && (
            <>
              <Title>Contact</Title>
              <Address>
                {name && (
                  <div>{name}</div>
                )}
                {street && (
                  <div>{street} {houseNumber}</div>
                )}
                {postcode && (
                  <span>{postcode}</span>
                )}
                {city && postcode && ' '}
                {city && (
                  <span>{city}</span>
                )}
              </Address>
              <ContactItems>
                {tel && (
                  <ContactItem>
                    <span>T:</span>
                    <CoreButton link linkHoverUnderline href={`tel:${telWithCountryCode}`}>{tel}</CoreButton>
                  </ContactItem>
                )}
                {tel2 && (
                  <ContactItem>
                    <span>T:</span>
                    <CoreButton link linkHoverUnderline href={`tel:${tel2WithCountryCode}`}>{tel2}</CoreButton>
                  </ContactItem>
                )}
                {email && (
                  <ContactItem>
                    <span>E:</span>
                    <CoreButton link linkHoverUnderline href={`mailto:${email}`}>{email}</CoreButton>
                  </ContactItem>
                )}
              </ContactItems>
            </>
          )}
          <StyledSocialmedia
            facebook={facebook}
            youtube={youtube}
            linkedin={linkedin}
            instagram={instagram}
            twitter={twitter}
            tiktok={tiktok}
          />
        </Wrapper>
      )}
      <Rating />
      {(items || []).length > 0 && (
        <PagebuilderProviders>
          {items.filter(({ inCoverNav }) => inCoverNav).map(({
            id,
            image,
            button,
          }) => (
            <Wrapper key={id} css="padding-bottom: 2rem">
              {image && (
                <Image image={image.image} />
              )}
              {button && (
                <PagebuilderButton
                  {...button}
                />
              )}
            </Wrapper>
          ))}
        </PagebuilderProviders>
      )}
    </article>
  );
};

const StyledSocialmedia = styled(Socialmedia)`
  margin-bottom: 1.5rem;
`;

const Title = styled.h2`
  font-size: 1.375rem;
  color: inherit;
  margin-bottom: 1.5rem;
`;

const Address = styled.address`
  font-style: normal;
  margin-bottom: 1.5rem;
`;

const ContactItem = styled.div`
  span {
    display: inline-block;
    min-width: 20px;
  }
`;

const ContactItems = styled.div`
  margin-bottom: 1.5rem;
`;

export default styled(Addons)`
  color: white;
  ${StyledSocialmedia} a {
    color: white;
  }
  line-height: ${({ theme }) => theme.baseLineHeight};

  ${ContactItems} a {
    color: inherit;
    text-decoration: none;
  }

  ${Wrapper} {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
`;
